import React, { useEffect, useState } from "react";
import { makeApi, URLS } from "Utils/apiURL";

const WA_CONNECTION_SUCCESS_MESSAGE = "wa-connection-success";

const WaSuccess = () => {
  const [status, setStatus] = useState("connecting"); // connecting | success | already_connected | error

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const accountId = params.get("account_id");

    const notifyOpenerAndClose = () => {
      try {
        if (window.opener && !window.opener.closed) {
          window.opener.postMessage(WA_CONNECTION_SUCCESS_MESSAGE, window.location.origin);
        }
      } catch (e) {
        // cross-origin or opener closed — parent will poll on its own
      }
      setTimeout(() => window.close(), 1500);
    };

    if (!accountId) {
      // No account_id in URL — notify_url callback already handled it
      setStatus("success");
      notifyOpenerAndClose();
      return;
    }

    const confirmConnection = async () => {
      try {
        const config = {
          url: URLS.connectWhatsAppAccount,
          method: "POST",
          data: { accountId }
        };
        const res = await makeApi(config);
        const responseCode = res?.data?.responseCode;
        if (+responseCode === 200) {
          setStatus("success");
          notifyOpenerAndClose();
        } else if (+responseCode === 409) {
          // Already connected (notify_url callback got here first) — still a success
          setStatus("success");
          notifyOpenerAndClose();
        } else {
          setStatus("error");
        }
      } catch (e) {
        setStatus("error");
      }
    };

    confirmConnection();
  }, []);

  if (status === "connecting") {
    return (
      <div className="waCallbackPage" style={{ padding: "40px 24px", textAlign: "center", fontFamily: "sans-serif" }}>
        <h2 style={{ color: "#25D366", marginBottom: "12px" }}>Connecting your WhatsApp account…</h2>
        <p style={{ color: "#555" }}>Please wait, this window will close automatically.</p>
      </div>
    );
  }

  if (status === "error") {
    return (
      <div className="waCallbackPage" style={{ padding: "40px 24px", textAlign: "center", fontFamily: "sans-serif" }}>
        <h2 style={{ color: "#c00", marginBottom: "12px" }}>Connection failed</h2>
        <p style={{ color: "#555", marginBottom: "24px" }}>Could not save your WhatsApp account. Please close this window and try again.</p>
        <button
          type="button"
          onClick={() => window.close()}
          style={{ padding: "10px 24px", background: "#666", color: "#fff", border: "none", borderRadius: "6px", cursor: "pointer", fontSize: "14px" }}
        >
          Close window
        </button>
      </div>
    );
  }

  return (
    <div className="waCallbackPage" style={{ padding: "40px 24px", textAlign: "center", fontFamily: "sans-serif" }}>
      <h2 style={{ color: "#25D366", marginBottom: "12px" }}>WhatsApp connected successfully!</h2>
      <p style={{ color: "#555" }}>This window will close automatically…</p>
    </div>
  );
};

export default WaSuccess;
export { WaSuccess };
